export default __webpack_public_path__ + "static/media/MDUnicktoe.4482408f.md";